import { useGetAllUsersQuery, useSwitchWholesalerStatusMutation } from "@RTKQuery/admin/customers/customers";
import { useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import style from "./Wholesale.module.scss";
import { Chip, SwitchButton } from "@ui";
import { RiLoader5Fill } from "react-icons/ri";
import { useEffect } from "react";

export function Wholesale() {
    const { id } = useParams();

    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeFilter } = useAppSelector(state => state.customersAdminPage);

    const { data } = useGetAllUsersQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        search: activeSearchIdParameter,
        is_active: activeFilter
    }, {
        selectFromResult: (res) => ({
            ...res, 
            data: res.data?.users.find(item => item.id === Number(id))
        })
    });

    const [switchWholesalerStatus, wholesalerStatus] = useSwitchWholesalerStatusMutation();

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (wholesalerStatus.isSuccess || wholesalerStatus.isError) {
            timer = setTimeout(() => {
                wholesalerStatus.reset()
            }, 3000)
        }

        return () => {
            clearTimeout(timer)
        }
    }, [wholesalerStatus]);

    return (
        <div className={style.wholesale}>
            <SwitchButton
                checked={Boolean(data?.is_wholesaler)}
                onChecked={() => {
                    switchWholesalerStatus({
                        user_id: Number(id),
                        status: !Boolean(data?.is_wholesaler)
                    })
                }}
                size="big"
            />
            <p>Оптовий клієнт</p>
            {
                wholesalerStatus.isError
                    ? <div className={style.status}>
                        <Chip
                            text="Помилка"
                            color="red"
                        />
                    </div>

                    : null
            }
            {
                wholesalerStatus.isSuccess
                    ? <div className={style.status}>
                        <Chip
                            text="Змінено"
                            color="green"
                        />
                    </div>

                    : null
            }
            {
                wholesalerStatus.isLoading
                    ?
                    <div className={style.status}>
                        <RiLoader5Fill className={"animate-spin"} />
                    </div>
                    : null
            }
        </div>
    )
}